module.exports = "/images/springer-logo.png?202320446ad316a7c3d7d8f19565d92f";